"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.867 5.005a3.945 3.945 0 0 1 5.567 0l2.051 2.043a3.945 3.945 0 0 1 0 5.59l-6.132 6.106H20.3a.7.7 0 1 1 0 1.4H8.673a3.95 3.95 0 0 1-2.783-1.15l-1.729-1.72a3.945 3.945 0 0 1 0-5.591zm-.498 13.74 1.624-1.618-5.657-5.634-1.187 1.182a2.545 2.545 0 0 0 0 3.606l1.729 1.722a2.55 2.55 0 0 0 1.795.741zm-3.04-8.24 5.657 5.634 4.511-4.493a2.545 2.545 0 0 0 0-3.606l-2.05-2.043a2.545 2.545 0 0 0-3.592 0z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EraserIcon24.js.map